var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-full h-auto",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 32 32",
    color: "#222343",
    "data-logo-name": "refresh",
    "aria-label": "refresh",
    style: {
      color: "rgb(34, 35, 67)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_1022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_1022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6665C13.0467 26.6665 10.5267 25.6265 8.44666 23.5465C6.36666 21.4665 5.32666 18.9532 5.32666 15.9932C5.32666 13.0332 6.36666 10.5198 8.44666 8.43982C10.5267 6.35982 13.04 5.31982 16 5.31982C17.8867 5.31982 19.5467 5.70649 20.9667 6.47316C22.3867 7.23982 23.62 8.29316 24.6667 9.62649V6.32649C24.6667 6.03982 24.76 5.79982 24.9533 5.60649C25.1467 5.41316 25.38 5.31982 25.6733 5.31982C25.9667 5.31982 26.2 5.41316 26.3933 5.60649C26.5867 5.79982 26.68 6.03316 26.68 6.32649V12.7932C26.68 13.0798 26.5867 13.3198 26.3933 13.5132C26.2 13.7065 25.9667 13.7998 25.6733 13.7998H19.2067C18.92 13.7998 18.68 13.7065 18.4867 13.5132C18.2933 13.3198 18.2 13.0865 18.2 12.7932C18.2 12.4998 18.2933 12.2665 18.4867 12.0732C18.68 11.8798 18.9133 11.7865 19.2067 11.7865H23.8067C22.96 10.4532 21.8867 9.37316 20.5733 8.55316C19.26 7.73316 17.74 7.31982 16.0067 7.31982C13.5867 7.31982 11.5333 8.15982 9.85333 9.83982C8.17333 11.5198 7.33333 13.5665 7.33333 15.9932C7.33333 18.4198 8.17333 20.4665 9.85333 22.1465C11.5333 23.8265 13.58 24.6665 16.0067 24.6665C17.6733 24.6665 19.2267 24.2265 20.6733 23.3465C22.12 22.4665 23.1933 21.2865 23.9067 19.7932C24.02 19.5465 24.2 19.3665 24.46 19.2398C24.72 19.1132 24.9667 19.1132 25.2133 19.2198C25.48 19.3332 25.66 19.5132 25.7467 19.7732C25.8333 20.0332 25.8267 20.2932 25.7133 20.5598C24.8467 22.4265 23.54 23.9132 21.7933 25.0132C20.0467 26.1132 18.12 26.6665 16.0067 26.6665H16Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5bcf48da54645fa6a0e60a113e358d85.svg";
export { ForwardRef as ReactComponent };